import React from "react";
import ClinicalTrialContainer from "./ClinicalTrial";
import { ClinicalTrialProvider } from "./ClinicalTrialContext";
import { AttachmentSlotPollingProvider } from "../../components/CustomControls/DocumentUpload/hooks/AttachmentSlotPollingProvider";

const ClinicalTrialContainerWrapper = (props) => (
  <ClinicalTrialProvider>
    {/* habilito short polling para attachments */}
    <AttachmentSlotPollingProvider intervalMs={3000}>
      <ClinicalTrialContainer {...props} />
    </AttachmentSlotPollingProvider>
  </ClinicalTrialProvider>
);

export default ClinicalTrialContainerWrapper;
